import React from 'react';
import AppHeader from '../../../../components/AppHeader';

/*
 This component is used for the Quest header if "showHeader" is set to true
*/
export default () => <AppHeader noLogoLink />;
